import React, { Component } from 'react';
import { 
        Card,
        CardHeader,
        CardBody,
        Container,
        Row,
        Col,
    } from 'reactstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { fetchCompanyList } from '../../redux/actions/aUser-CompanyList'
import { fetchMasterOutbound } from '../../redux/actions/stck.masteroutboundwithItem.act'
import SummaryWidgets from '../Widgets/SummaryWidgets'

class TransportedItemDatatable extends Component {

    constructor(props) {
        super(props);
        this.props.fetchCompanyList(this.props.match.params.key)
        this.props.fetchMasterOutbound(this.props.match.params.key, this.props.match.params.id_outbound)
        this.state = {
            companyListData: [],
            stckMasterOutboundData: null,
            stckMasterOutboundItem: []
        }
    }

    componentDidUpdate(prevProps){
        const {companyListData, stckMasterOutboundData, stckMasterOutboundItem} = this.props
        if(prevProps.companyListData !== companyListData){
            this.setState({
                companyListData: companyListData.result? companyListData.result[0]: []
            })
        }
        if(prevProps.stckMasterOutboundItem !== stckMasterOutboundItem)
            this.setState({
                stckMasterOutboundItem: stckMasterOutboundItem? stckMasterOutboundItem.result : []
            })
        if(prevProps.stckMasterOutboundData !== stckMasterOutboundData){
            if(!stckMasterOutboundData.result)
                return
            if(!stckMasterOutboundData.result[0])
                return
            this.setState({
                stckMasterOutboundData: stckMasterOutboundData.result[0].outbound_number
            })
        }
    }

    showDatatable = () => {
        const {stckMasterOutboundItem} = this.state
        const {stckTotalMasterOutboundItem} = this.props
        let options = {
            noDataText: 'No items registered. Try one-lah!',
            sizePerPageList: [{
                text: '10', value: 10
            },{
                text: '25', value: 25
            },{
                text: '50', value: 50
            }],
            sizePerPage: 20,
            btnGroup: this.customBtnGroup,
        };
        return (
            <React.Fragment>
                <Row>
                    <Col md={3} xs={12}>
                        <SummaryWidgets header={stckTotalMasterOutboundItem} mainText={'Total Item(s)'} icon={'fa fa-archive'} color={'info'}/>
                    </Col>
                </Row>
                <BootstrapTable data={stckMasterOutboundItem} version="4" striped hover pagination search edit options={options} exportCSV={false} csvFileName={this.fileNameFormat} multiColumnSearch>
                    <TableHeaderColumn dataField="id" isKey dataSort csvHeader="ID" searchable={false} hidden>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField="item_name" searchable dataSort csvHeader="Item Name" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Item Name</TableHeaderColumn>
                    <TableHeaderColumn dataField="batch_number" searchable dataSort csvHeader="Batch Number" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Batch Number</TableHeaderColumn>
                    <TableHeaderColumn dataField="realization_qty" searchable dataSort csvHeader="Delivered Qty" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Delivered Qty</TableHeaderColumn>
                    <TableHeaderColumn dataField="production_date" searchable dataSort csvHeader="Production Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Production Date</TableHeaderColumn>
                    <TableHeaderColumn dataField="expired_date" searchable dataSort csvHeader="Expired Date" thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } width="20%">Expiry</TableHeaderColumn>
                </BootstrapTable>
            </React.Fragment>
        )
    }

    render(){
        const {companyListData, stckMasterOutboundData} = this.state
        const {mode} = this.props.match.params
        return(
            <Container fluid style={{"max-width": "1280px"}}>
                <br />
                <Card>
                    <CardHeader>
                        {mode === "owned"?
                            "Your Profile"
                            : null
                        }
                        {mode === "tripl"?
                            "Requestor Profile"
                            : null
                        }
                    </CardHeader>
                    <CardBody>
                    <Row>
                        <Col xs={12} md={4}    
                            style={{"background":"#f1f2f6"}}>
                            <img width="100%" height="auto" 
                                style={{"margin-top": "55px"}}
                                src={companyListData !== []? companyListData.link_logo : null}
                                alt="Company Logo" />
                        </Col>
                        <br />
                        <Col xs={12} md={4}>
                                <h3>Company</h3>
                                <p style={{"font-size":"12pt"}}>{companyListData.company}</p><br />
                                <h3>Contact</h3>
                                <p style={{"font-size":"12pt"}}>
                                    <i class="fa fa-envelope" style={{color:"#33b5e5"}}></i>&nbsp;&nbsp;
                                    {companyListData.company_email}
                                </p>
                                <p style={{"font-size":"12pt"}}>
                                    <i class="fa fa-phone" style={{color:"#33b5e5"}}></i>&nbsp;&nbsp;
                                    {companyListData.telp}
                                </p><br />
                        </Col>
                        <Col xs={12} md={4}>
                            <h3>Address</h3>
                            <p style={{"font-size":"12pt"}}>{companyListData.company_address}</p><br />
                        </Col>
                    </Row>
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader>
                        <b>{stckMasterOutboundData? stckMasterOutboundData : "Your "}</b> Transported Item
                    </CardHeader>
                    <CardBody>
                    {this.showDatatable()}
                    </CardBody>
                </Card>
            </Container>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        companyListData: state.companyList.companyListData,
        inProgressCompanyList : state.companyList.inProgress,
        successCompanyList: state.companyList.success,

        stckMasterOutboundData: state.masterOutboundStore.stckMasterOutboundData,
        stckTotalMasterOutboundItem: state.masterOutboundStore.stckTotalMasterOutboundItem,
        stckMasterOutboundItem: state.masterOutboundStore.stckMasterOutboundItem,
        inProgressMasterOutbound: state.masterOutboundStore.inProgressMasterOutbound,
        successMasterOutbound: state.masterOutboundStore.successMasterOutbound
    }
}

export default connect(mapStateToProps, {fetchCompanyList, fetchMasterOutbound})(TransportedItemDatatable);


// WEBPACK FOOTER //
// ./src/views/Stocker/TransportedItemDatatable.jsx